var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactSurveyElementsWrapper } from "./reactsurveymodel";
import { ReactElementFactory } from "./element-factory";
import { SurveyElementBase, ReactSurveyElement } from "./reactquestion_element";
import { SurveyQuestionCommentItem } from "./reactquestion_comment";
import { SurveyCustomWidget } from "./custom-widget";
import { SurveyElementHeader } from "./element-header";
import { SurveyQuestionSigleInputSummary } from "./reactquestion_singleinputsummary";
import { SurveyBreadcrumbs } from "./components/breadcrumbs/breadcrumbs";
var SurveyQuestion = /** @class */ (function (_super) {
    __extends(SurveyQuestion, _super);
    function SurveyQuestion(props) {
        var _this = _super.call(this, props) || this;
        _this.isNeedFocus = false;
        _this.rootRef = React.createRef();
        return _this;
    }
    SurveyQuestion.renderQuestionBody = function (creator, question) {
        // if (!question.isVisible) return null;
        var customWidget = question.customWidget;
        if (!customWidget) {
            return creator.createQuestionElement(question);
        }
        return React.createElement(SurveyCustomWidget, { creator: creator, question: question });
    };
    SurveyQuestion.prototype.getStateElement = function () {
        return this.question;
    };
    Object.defineProperty(SurveyQuestion.prototype, "question", {
        get: function () {
            return this.props.element;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestion.prototype, "creator", {
        get: function () {
            return this.props.creator;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestion.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        if (!!this.question) {
            this.question["react"] = this;
        }
        this.doAfterRender();
    };
    SurveyQuestion.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        if (!!this.question) {
            this.question["react"] = null;
        }
        var el = this.rootRef.current;
        if (!!el) {
            el.removeAttribute("data-rendered");
        }
    };
    SurveyQuestion.prototype.componentDidUpdate = function (prevProps, prevState) {
        _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
        this.doAfterRender();
    };
    SurveyQuestion.prototype.doAfterRender = function () {
        if (this.isNeedFocus) {
            if (!this.question.isCollapsed) {
                this.question.clickTitleFunction();
            }
            this.isNeedFocus = false;
        }
        if (this.question) {
            var el = this.rootRef.current;
            if (el && el.getAttribute("data-rendered") !== "r") {
                el.setAttribute("data-rendered", "r");
                if (this.question.afterRender) {
                    this.question.afterRender(el);
                }
            }
        }
    };
    SurveyQuestion.prototype.canRender = function () {
        return (_super.prototype.canRender.call(this) &&
            !!this.question &&
            !!this.creator);
    };
    SurveyQuestion.prototype.renderQuestionContent = function () {
        var question = this.question;
        var contentStyle = {
            display: this.question.renderedIsExpanded ? "" : "none",
        };
        var cssClasses = question.cssClasses;
        var questionRender = this.renderQuestion();
        var comment = question && question.hasComment ? this.renderComment(cssClasses) : null;
        var descriptionUnderInput = question.hasDescriptionUnderInput
            ? this.renderDescription()
            : null;
        return (React.createElement("div", { className: question.cssContent || undefined, style: contentStyle, "aria-hidden": question.contentAriaHidden, role: "presentation", "data-sv-drop-target-matrix": this.question.dragDropMatrixAttribute, "data-sv-drop-target-matrix-row": this.question.dragDropMatrixAttribute },
            questionRender,
            comment,
            descriptionUnderInput));
    };
    SurveyQuestion.prototype.renderElement = function () {
        var question = this.question;
        var cssClasses = question.cssClasses;
        var header = this.renderHeader(question);
        var headerTop = question.hasTitleOnLeftTop ? header : null;
        var headerBottom = question.hasTitleOnBottom ? header : null;
        var errorsAboveQuestion = this.question.showErrorsAboveQuestion
            ? this.renderErrors(cssClasses, "")
            : null;
        var errorsBelowQuestion = this.question.showErrorsBelowQuestion
            ? this.renderErrors(cssClasses, "")
            : null;
        var rootStyle = question.getRootStyle();
        var singleBreadcrumbs = question.singleInputHasActions ? this.renderSingleInputBreadcrumbs(question, cssClasses) : undefined;
        var singleSummary = question.singleInputSummary ? this.renderSingleInputSummary(question, cssClasses) : undefined;
        var singleInput = singleSummary || (question.singleInputQuestion ? this.renderSingleInputQuestion(question, cssClasses) : undefined);
        var questionContent = singleInput || this.wrapQuestionContent(this.renderQuestionContent());
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { ref: this.rootRef, id: question.id, className: question.getRootCss(), style: rootStyle, "data-name": question.name, role: question.ariaRole, "aria-required": this.question.ariaRequired, "aria-invalid": this.question.ariaInvalid, "aria-label": this.question.ariaLabel, "aria-labelledby": question.ariaLabelledBy, "aria-describedby": question.ariaDescribedBy, "aria-expanded": question.ariaExpanded },
                singleBreadcrumbs,
                errorsAboveQuestion,
                headerTop,
                questionContent,
                headerBottom,
                errorsBelowQuestion)));
    };
    SurveyQuestion.prototype.renderSingleInputQuestion = function (question, cssClasses) {
        var singleQuestion = question.singleInputQuestion;
        var key = singleQuestion.id;
        return React.createElement(SurveyQuestion, { key: key, element: singleQuestion, creator: this.creator, css: cssClasses });
    };
    SurveyQuestion.prototype.renderSingleInputBreadcrumbs = function (question, cssClasses) {
        return React.createElement(SurveyBreadcrumbs, { model: question.singleInputActions, css: cssClasses });
    };
    SurveyQuestion.prototype.renderSingleInputSummary = function (question, cssClasses) {
        return React.createElement(SurveyQuestionSigleInputSummary, { summary: question.singleInputSummary, creator: this.creator, css: cssClasses });
    };
    SurveyQuestion.prototype.wrapElement = function (element) {
        var survey = this.question.survey;
        var wrapper = null;
        if (survey) {
            wrapper = ReactSurveyElementsWrapper.wrapElement(survey, element, this.question);
        }
        return wrapper !== null && wrapper !== void 0 ? wrapper : element;
    };
    SurveyQuestion.prototype.wrapQuestionContent = function (element) {
        var survey = this.question.survey;
        var wrapper = null;
        if (survey) {
            wrapper = ReactSurveyElementsWrapper.wrapQuestionContent(survey, element, this.question);
        }
        return wrapper !== null && wrapper !== void 0 ? wrapper : element;
    };
    SurveyQuestion.prototype.renderQuestion = function () {
        return SurveyQuestion.renderQuestionBody(this.creator, this.question);
    };
    SurveyQuestion.prototype.renderDescription = function () {
        return SurveyElementBase.renderQuestionDescription(this.question);
    };
    SurveyQuestion.prototype.renderComment = function (cssClasses) {
        var commentText = SurveyElementBase.renderLocString(this.question.locCommentText);
        return (React.createElement("div", { className: this.question.getCommentAreaCss() },
            React.createElement("div", null, commentText),
            React.createElement(SurveyQuestionCommentItem, { question: this.question, cssClasses: cssClasses, isDisplayMode: this.question.isInputReadOnly })));
    };
    SurveyQuestion.prototype.renderHeader = function (question) {
        return React.createElement(SurveyElementHeader, { element: question });
    };
    SurveyQuestion.prototype.renderErrors = function (cssClasses, location) {
        return (React.createElement(SurveyElementErrors, { element: this.question, cssClasses: cssClasses, creator: this.creator, location: location, id: this.question.id + "_errors" }));
    };
    return SurveyQuestion;
}(SurveyElementBase));
export { SurveyQuestion };
ReactElementFactory.Instance.registerElement("question", function (props) {
    return React.createElement(SurveyQuestion, props);
});
var SurveyElementErrors = /** @class */ (function (_super) {
    __extends(SurveyElementErrors, _super);
    function SurveyElementErrors(props) {
        var _this = _super.call(this, props) || this;
        _this.state = _this.getState();
        return _this;
    }
    Object.defineProperty(SurveyElementErrors.prototype, "id", {
        get: function () {
            return this.props.element.id + "_errors";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyElementErrors.prototype, "element", {
        get: function () {
            return this.props.element;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyElementErrors.prototype, "creator", {
        get: function () {
            return this.props.creator;
        },
        enumerable: false,
        configurable: true
    });
    SurveyElementErrors.prototype.getState = function (prevState) {
        if (prevState === void 0) { prevState = null; }
        return !prevState ? { error: 0 } : { error: prevState.error + 1 };
    };
    SurveyElementErrors.prototype.canRender = function () {
        return !!this.element && this.element.hasVisibleErrors;
    };
    SurveyElementErrors.prototype.componentWillUnmount = function () {
    };
    SurveyElementErrors.prototype.renderElement = function () {
        var errors = [];
        for (var i = 0; i < this.element.renderedErrors.length; i++) {
            var key = "error" + i;
            errors.push(this.creator.renderError(key, this.element.renderedErrors[i], this.cssClasses, this.element));
        }
        return (React.createElement("div", { className: this.element.cssError, id: this.id }, errors));
    };
    return SurveyElementErrors;
}(ReactSurveyElement));
export { SurveyElementErrors };
var SurveyQuestionAndErrorsWrapped = /** @class */ (function (_super) {
    __extends(SurveyQuestionAndErrorsWrapped, _super);
    function SurveyQuestionAndErrorsWrapped(props) {
        return _super.call(this, props) || this;
    }
    SurveyQuestionAndErrorsWrapped.prototype.getStateElement = function () {
        return this.question;
    };
    Object.defineProperty(SurveyQuestionAndErrorsWrapped.prototype, "question", {
        get: function () {
            return this.getQuestion();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionAndErrorsWrapped.prototype, "creator", {
        get: function () {
            return this.props.creator;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionAndErrorsWrapped.prototype.getQuestion = function () {
        return this.props.question;
    };
    Object.defineProperty(SurveyQuestionAndErrorsWrapped.prototype, "itemCss", {
        get: function () {
            return this.props.itemCss;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionAndErrorsWrapped.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        this.doAfterRender();
    };
    SurveyQuestionAndErrorsWrapped.prototype.componentDidUpdate = function (prevProps, prevState) {
        _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
        this.doAfterRender();
    };
    SurveyQuestionAndErrorsWrapped.prototype.doAfterRender = function () { };
    SurveyQuestionAndErrorsWrapped.prototype.canRender = function () {
        return !!this.question;
    };
    SurveyQuestionAndErrorsWrapped.prototype.renderContent = function () {
        var renderedQuestion = this.renderQuestion();
        return (React.createElement(React.Fragment, null, renderedQuestion));
    };
    SurveyQuestionAndErrorsWrapped.prototype.getShowErrors = function () {
        return this.question.isVisible;
    };
    SurveyQuestionAndErrorsWrapped.prototype.renderQuestion = function () {
        return SurveyQuestion.renderQuestionBody(this.creator, this.question);
    };
    return SurveyQuestionAndErrorsWrapped;
}(ReactSurveyElement));
export { SurveyQuestionAndErrorsWrapped };
var SurveyQuestionAndErrorsCell = /** @class */ (function (_super) {
    __extends(SurveyQuestionAndErrorsCell, _super);
    function SurveyQuestionAndErrorsCell(props) {
        var _this = _super.call(this, props) || this;
        _this.cellRef = React.createRef();
        return _this;
    }
    SurveyQuestionAndErrorsCell.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        if (this.question) {
            var el = this.cellRef.current;
            if (!!el) {
                el.removeAttribute("data-rendered");
            }
        }
    };
    SurveyQuestionAndErrorsCell.prototype.renderCellContent = function () {
        return (React.createElement("div", { className: this.props.cell.cellQuestionWrapperClassName }, this.renderQuestion()));
    };
    SurveyQuestionAndErrorsCell.prototype.renderElement = function () {
        var style = this.getCellStyle();
        var cell = this.props.cell;
        var focusIn = function () { cell.focusIn(); };
        return (React.createElement("td", { ref: this.cellRef, className: this.itemCss, colSpan: cell.colSpans, title: cell.getTitle(), style: style, onFocus: focusIn }, this.wrapCell(this.props.cell, this.renderCellContent())));
    };
    SurveyQuestionAndErrorsCell.prototype.getCellStyle = function () {
        return null;
    };
    SurveyQuestionAndErrorsCell.prototype.getHeaderText = function () {
        return "";
    };
    SurveyQuestionAndErrorsCell.prototype.wrapCell = function (cell, element) {
        if (!cell) {
            return element;
        }
        var survey = this.question.survey;
        var wrapper = null;
        if (survey) {
            wrapper = ReactSurveyElementsWrapper.wrapMatrixCell(survey, element, cell, this.props.reason);
        }
        return wrapper !== null && wrapper !== void 0 ? wrapper : element;
    };
    return SurveyQuestionAndErrorsCell;
}(SurveyQuestionAndErrorsWrapped));
export { SurveyQuestionAndErrorsCell };
var SurveyQuestionErrorCell = /** @class */ (function (_super) {
    __extends(SurveyQuestionErrorCell, _super);
    function SurveyQuestionErrorCell(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            changed: 0
        };
        if (_this.question) {
            _this.registerCallback(_this.question);
        }
        return _this;
    }
    Object.defineProperty(SurveyQuestionErrorCell.prototype, "question", {
        get: function () {
            return this.props.question;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionErrorCell.prototype.update = function () {
        this.setState({ changed: this.state.changed + 1 });
    };
    SurveyQuestionErrorCell.prototype.getQuestionPropertiesToTrack = function () {
        return ["errors"];
    };
    SurveyQuestionErrorCell.prototype.registerCallback = function (question) {
        var _this = this;
        question.registerFunctionOnPropertiesValueChanged(this.getQuestionPropertiesToTrack(), function () {
            _this.update();
        }, "__reactSubscription");
    };
    SurveyQuestionErrorCell.prototype.unRegisterCallback = function (question) {
        question.unRegisterFunctionOnPropertiesValueChanged(this.getQuestionPropertiesToTrack(), "__reactSubscription");
    };
    SurveyQuestionErrorCell.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.question && prevProps.question !== this.question) {
            this.unRegisterCallback(prevProps.cell);
        }
        if (this.question) {
            this.registerCallback(this.question);
        }
    };
    SurveyQuestionErrorCell.prototype.componentWillUnmount = function () {
        if (this.question) {
            this.unRegisterCallback(this.question);
        }
    };
    SurveyQuestionErrorCell.prototype.render = function () {
        return React.createElement(SurveyElementErrors, { element: this.question, creator: this.props.creator, cssClasses: this.question.cssClasses });
    };
    return SurveyQuestionErrorCell;
}(React.Component));
export { SurveyQuestionErrorCell };
